import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import { Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import Autocomplete from "@mui/material/Autocomplete";
import { Divider } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import dayjs, { Dayjs } from "dayjs";
import api from "../../../utils/Url";

type Props = {};

const UserManagementAdd = (props: Props) => {
  const { t } = useTranslation();

  const [option, setOption] = useState([{
    value: "-1", label:
      t("text.SelectGender")
  }]);
  const [option1, setOption1] = useState([{ value: "-1", label: t("text.SelectRole") }]);
  const [option2, setOption2] = useState([{ value: "-1", label: t("text.SelectUserType") }]);
  const [UserName, setUserName] = useState([{ value: "-1", label: t("text.SelectEmployee") }]);
  const [DepartmentOption, setDepartmentOption] = useState([{ value: "-1", label: t("text.SelectDepartment") }]);



  let navigate = useNavigate();

  const back = useNavigate();

  const getGender = () => {
    const collectData = {
      genderID: -1,
    };
    api
      .post(`Gender/GetGenderMaster`, collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["genderName"],
            value: res.data.data[index]["genderID"],
          });
        }
        setOption(arr);
      });
  };

  const getdepartment = () => {
    const collectData = {
      departmentId: -1,
    };
    api
      .post(`Department/GetDepartmentmaster`, collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["departmentName"],
            value: res.data.data[index]["departmentId"],
          });
        }
        setDepartmentOption(arr);
      });
  };


  const getRole = () => {
    const collectData = {
      roleId: "-1",
    };
    api
      .post(`RoleMaster/GetRoleMaster`, collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["roleName"],
            value: res.data.data[index]["roleId"],
          });
        }
        setOption1(arr);
      });
  };

  const getUserType = () => {
    const collectData = {
      useR_TYPE_ID: -1,
    };
    api
      .post(`USER_TYPE/GetUSER_TYPE`, collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["useR_TYPE_NAME"],
            value: res.data.data[index]["useR_TYPE_ID"],
          });
        }
        setOption2(arr);
      });
  };


  const getUserName = () => {
    const collectData = {
      "empid": -1,
      "userId": "",
      "empName": "",
      "empMobileNo": "",
      "empDesignationId": -1,
      "empDeptId": -1,
      "empStateId": -1,
      "empCountryID": -1,
      "empCityId": -1,
      "empPincode": 0,
      "roleId": ""
    };
    api
      .post(`EmpMaster/GetEmpmaster`, collectData)
      .then((res) => {
        const arr = [];
        console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            firsT_NAME: res.data.data[index]["empName"],
            departmentId: res.data.data[index]["empDeptId"],

            // logiN_NAME: res.data.data[index]["empName"],
            // password: res.data.data[index]["password"],
            useR_CODE: res.data.data[index]["empCode"],
            cuR_MOBILE: res.data.data[index]["empMobileNo"],
            email: res.data.data[index]["email"],
            dob: res.data.data[index]["empDob"],
            gendeR_ID: res.data.data[index]["gender"],
            rolename: res.data.data[index]["roleId"],
            // useR_TYPE_ID: res.data.data[index]["useR_TYPE_ID"],
            label: res.data.data[index]["empName"],
            value: res.data.data[index]["empid"],
          });
        }
        setUserName(arr);
      });
  };








  const [toaster, setToaster] = useState(false);

  useEffect(() => {
    getRole();
    getGender();
    getUserType();
    getUserName();
    getdepartment();
  }, []);

  const validationSchema = Yup.object({
    firsT_NAME: Yup.string().test(
      "required",
      // "First Name Required",
      t("text.reqFirst"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),

    logiN_NAME: Yup.string().test(
      "required",
      // "login ID Required",
      t("text.reqLogin"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    password: Yup.string().test(
      "required",
      // "Password Required",
      t("text.reqPassword"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    cuR_MOBILE: Yup.string()
      // .required("Mobile Number Required")
      .required(t("text.reqMobile"))
      .test(
        // "is-valid-mobile",
        t("text.validMobile"),
        // "Invalid mobile number format",
        t("text.InvalidMobile"),
        function (value: any) {
          const trimmedValue = value.trim();
          if (trimmedValue && trimmedValue.length === 10) {
            if (trimmedValue.charAt(0) === '0') {
              return false;
            }
            return true;
          }
          return false;
        }
      ),
    email: Yup.string()
      // .required("Email ID Required")
      .required(t("text.reqEmail"))
      .test(
        // "is-valid-email",
        t("text.validEmai"),
        t("text.InvalidEmail"),
        // "Invalid email format",
        function (value: any) {
          const trimmedValue = value.trim();
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedValue);
        }
      ),
    dob: Yup.string().test(
      "required",
      // "Date of Birth Required",
      t("text.reqDate"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    gendeR_ID: Yup.string().test(
      "required",
      // "Gender Required",
      t("text.reqGender"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    useR_TYPE_ID: Yup.string().test(
      "required",
      // "User Type Required",
      t("text.reqUser"),

      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    ranK_ID: Yup.string().test(
      "required",
      // "Role Required",
      t("text.reqRole"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
  });

  const formik = useFormik({
    initialValues: {
      useR_ID: "-1",
      ranK_ID: "",
      suR_NAME: "",
      firsT_NAME: "",
      middlE_NAME: "",
      shorT_NAME: "",
      useR_CODE: "",
      dob: "",
      doa: "",
      doj: "",
      gendeR_ID: "",
      cuR_PHONE: "",
      cuR_MOBILE: "",
      email: "",
      iS_ACTIVE: true,
      iS_DELETED: false,
      useR_TYPE_ID: "",
      otp: "",
      logiN_NAME: "",
      password: "",
      rolename: "",
      departmentId: -1,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      values.doa = "1900-01-01T07:47:27.349Z";
      values.doj = "1900-01-01T07:47:27.349Z";

      const response = await api.post(
        `USER/AddUpdateUSER`,
        values
      );
      if (response.data.isSuccess) {
        setToaster(false);
        toast.success(response.data.mesg);
      } else {
        setToaster(true);
        toast.error(response.data.mesg);
      }
      navigate("/UserManagement/UserManagement");
    },
  });

  const requiredFields = [
    "firsT_NAME",

    "logiN_NAME",
    "password",
    "cuR_MOBILE",
    "email",
    "dob",
    "gendeR_ID",
    "useR_TYPE_ID",
    "rolename",
  ];

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#FFFFFF",
          borderRadius: "5px",
          border: ".5px solid #ff7722",
          marginTop: "3vh"
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ marginTop: "10px", fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.CreateUserManegment")}
          </Typography>
          <Grid xs={4} sm={12} item>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: "blue",
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              <Grid xs={12} sm={4} item>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={UserName}
                  fullWidth
                  // value={CheckMode}
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    console.log(newValue);
                    formik.setFieldValue("firsT_NAME", newValue?.firsT_NAME);
                    formik.setFieldValue("departmentId", newValue?.departmentId);

                    // formik.setFieldValue("logiN_NAME", newValue?.logiN_NAME);
                    // formik.setFieldValue("password", newValue?.password);
                    formik.setFieldValue("useR_CODE", newValue?.useR_CODE);
                    formik.setFieldValue("cuR_MOBILE", newValue?.cuR_MOBILE);
                    formik.setFieldValue("email", newValue?.email);
                    formik.setFieldValue("dob", newValue?.dob);
                    formik.setFieldValue("gendeR_ID", parseInt(newValue?.gendeR_ID));
                    formik.setFieldValue("ranK_ID", newValue?.rolename);
                    // formik.setFieldValue("useR_TYPE_ID", newValue?.useR_TYPE_ID);

                    formik.setFieldValue("User_NAME", newValue?.label);
                  }}
                  style={{ backgroundColor: "white" }}
                  renderInput={(params) => (
                    <TextField {...params} label={t("text.SelectEmployee")} />
                  )}
                />
              </Grid>

              <Grid xs={12} sm={4} item></Grid>
              <Grid xs={12} sm={4} item></Grid>


              <Grid xs={12} sm={4} item>
                <TextField
                  type="text"
                  label={
                    <span>
                      {t("text.EnterFirstName")} {" "}
                      {requiredFields.includes("firsT_NAME") && (
                        <span
                          style={{
                            color: formik.values.firsT_NAME ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.firsT_NAME}
                  name="firsT_NAME"
                  id="firsT_NAME"
                  placeholder={t("text.EnterFirstName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.firsT_NAME && formik.errors.firsT_NAME ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.firsT_NAME)}
                  </div>
                ) : null}
              </Grid>








              <Grid xs={12} sm={4} item>
                <TextField
                  type="text"
                  label={
                    <span>
                      {t("text.EnterLoginName")}{" "}
                      {requiredFields.includes("logiN_NAME") && (
                        <span
                          style={{
                            color: formik.values.logiN_NAME ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  name="logiN_NAME"
                  id="logiN_NAME"
                  value={formik.values.logiN_NAME}
                  placeholder={t("text.EnterLoginName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.logiN_NAME && formik.errors.logiN_NAME ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.logiN_NAME}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="password"
                  label={
                    <span>
                      {t("text.EnterPassword")} {" "}
                      {requiredFields.includes("password") && (
                        <span
                          style={{
                            color: formik.values.password ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.password}
                  name="password"
                  id="password"
                  placeholder={t("text.EnterPassword")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.password && formik.errors.password ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.password}
                  </div>
                ) : null}
              </Grid>



              <Grid xs={12} sm={4} item>
                <TextField
                  type="text"
                  label={
                    <span>
                      {t("text.EnterMobileNo")} {" "}
                      {requiredFields.includes("cuR_MOBILE") && (
                        <span
                          style={{
                            color: formik.values.cuR_MOBILE ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  inputProps={{ maxLength: 10 }}
                  name="cuR_MOBILE"
                  id="cuR_MOBILE"
                  value={formik.values.cuR_MOBILE}
                  placeholder={t("text.EnterMobileNo")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.cuR_MOBILE && formik.errors.cuR_MOBILE ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.cuR_MOBILE}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="email"
                  label={
                    <span>
                      {t("text.EnterEmailId")}{" "}
                      {requiredFields.includes("email") && (
                        <span
                          style={{
                            color: formik.values.email ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  name="email"
                  id="email"
                  InputLabelProps={{ shrink: true }}
                  value={formik.values.email}
                  placeholder={t("text.EnterEmailId")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.email}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <TextField
                  type="Date"
                  InputLabelProps={{ shrink: true }}
                  label={
                    <span>
                      {t("text.EnterDateOfBirth")} {" "}
                      {requiredFields.includes("dob") && (
                        <span
                          style={{ color: formik.values.dob ? "green" : "red" }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  name="dob"
                  id="dob"
                  placeholder={t("text.EnterDateOfBirth")}
                  value={dayjs(formik.values.dob).format("YYYY-MM-DD")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.dob && formik.errors.dob ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.dob}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={option}
                  fullWidth
                  size="small"
                  // value={
                  //   option.find(
                  //     (option) => option.value === formik.values.gendeR_ID
                  //   ) || null
                  // }

                  value={{ value: "male", label: "Male" }}

                  onChange={(event, newValue) => {
                    formik.setFieldValue("gendeR_ID", newValue?.value);
                    formik.setFieldTouched("gendeR_ID", true);
                    formik.setFieldTouched("gendeR_ID", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectGender")} {""}
                          {requiredFields.includes("gendeR_ID") && (
                            <span
                              style={{
                                color: formik.values.gendeR_ID
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.gendeR_ID && formik.errors.gendeR_ID ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.gendeR_ID}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={option1}
                  fullWidth
                  
                   value={
                    option1.find(
                      (option:any) => option.value+"" === formik.values.ranK_ID
                    ) || null
                  }
                  size="small"
                  onChange={(event, newValue:any) => {
                    formik.setFieldValue("ranK_ID", newValue?.value+"");
                    formik.setFieldValue("rolename", newValue?.label);
                    formik.setFieldTouched("rolename", true);
                    formik.setFieldTouched("rolename", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectRole")} {""}
                          {requiredFields.includes("rolename") && (
                            <span
                              style={{
                                color: formik.values.rolename
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.rolename && formik.errors.rolename ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.rolename}
                  </div>
                ) : null}
              </Grid>

              <Grid xs={12} sm={4} item>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={option2}
                  fullWidth
                  size="small"
                  value={
                    option2.find(
                      (option) => option.value === formik.values.useR_TYPE_ID
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    formik.setFieldValue("useR_TYPE_ID", newValue?.value);
                    formik.setFieldTouched("useR_TYPE_ID", true);
                    formik.setFieldTouched("useR_TYPE_ID", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectUserType")} {""}
                          {requiredFields.includes("useR_TYPE_ID") && (
                            <span
                              style={{
                                color: formik.values.useR_TYPE_ID
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.useR_TYPE_ID && formik.errors.useR_TYPE_ID ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.useR_TYPE_ID}
                  </div>
                ) : null}
              </Grid>


              <Grid xs={12} sm={4} item>
              <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={DepartmentOption}
                  fullWidth
                  
                   value={
                    DepartmentOption.find(
                      (option:any) => option.value === formik.values.departmentId
                    ) || null
                  }
                  size="small"
                  onChange={(event, newValue) => {
                    //formik.setFieldValue("ranK_ID", newValue?.value);
                    formik.setFieldValue("departmentId", newValue?.value);
                    formik.setFieldTouched("departmentId", true);
                    formik.setFieldTouched("departmentId", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectDepartment")} {""}
                          {requiredFields.includes("departmentId") && (
                            <span
                              style={{
                                color: formik.values.departmentId
                                  ? "green"
                                  : "red",
                              }}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />
                {formik.touched.departmentId && formik.errors.departmentId ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {formik.errors.departmentId}
                  </div>
                ) : null}
              </Grid>









              <Grid xs={12} item>
                <div style={{ justifyContent: "space-between", flex: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      width: "48%",
                      backgroundColor: "#059669",
                      margin: "1%",
                    }}
                  >
                    {t("text.save")}
                  </Button>

                  <Button
                    type="reset"
                    variant="contained"
                    style={{
                      width: "48%",
                      backgroundColor: "#F43F5E",
                      margin: "1%",
                    }}
                    onClick={() => formik.resetForm()}
                  >
                    {t("text.reset")}
                  </Button>
                </div>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};
export default UserManagementAdd;
